import { render, staticRenderFns } from "./PerLocationsTrafficRefactored.vue?vue&type=template&id=764974d3&"
import script from "./PerLocationsTrafficRefactored.vue?vue&type=script&lang=js&"
export * from "./PerLocationsTrafficRefactored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports